import { URLSearchParams } from 'url';
import { addDays } from 'utils/utils';

export class SearchTransferModel {
  people: number;
  countryCodeFrom: string;
  countryCodeTo: string;
  departureDate: Date;
  returnDate: Date;
  pickup: TransferPosition;
  dropoff: TransferPosition;
  searchType: string;
  oneWay: boolean = false;
  recaptchaToken?: string;

  constructor(url?: URLSearchParams, recaptchaToken?: string) {
    if (url) {
      const paramsObj = Object.fromEntries(url.entries());
      this.people = parseInt(paramsObj.people);
      this.countryCodeFrom = paramsObj.countryCodeFrom;
      this.countryCodeTo = paramsObj.countryCodeTo;
      this.departureDate = new Date(paramsObj.departureDate);
      this.returnDate = new Date(paramsObj.returnDate);
      this.pickup = {
        code: paramsObj['pickup.code'],
        desc: paramsObj['pickup.desc'],
        latitude: paramsObj['pickup.latitude'],
        longitude: paramsObj['pickup.longitude'],
        type: +paramsObj['pickup.type'],
      };
      this.dropoff = {
        code: paramsObj['dropoff.code'],
        desc: paramsObj['dropoff.desc'],
        latitude: paramsObj['dropoff.latitude'],
        longitude: paramsObj['dropoff.longitude'],
        type: +paramsObj['dropoff.type'],
      };
      this.searchType = paramsObj.searchType || paramsObj.oneWay === 'true' ? '0' : '1';
      this.oneWay = paramsObj.searchType === '0';
      this.recaptchaToken = recaptchaToken;
    } else {
      const minutesRound = Math.ceil(new Date().getMinutes() / 10) * 10;
      const hoursRound = minutesRound === 60 ? new Date().getHours() + 1 : new Date().getHours();

      const dateRouned = new Date().setHours(hoursRound, minutesRound, 0, 0);

      this.people = 2;
      this.countryCodeFrom = 'FR';
      this.countryCodeTo = '';
      this.departureDate = addDays(7, new Date(dateRouned));
      this.returnDate = addDays(14, new Date(dateRouned));

      this.pickup = {
        code: '',
        desc: '',
        latitude: '',
        longitude: '',
        type: 0,
      };
      this.dropoff = {
        code: '',
        desc: '',
        latitude: '',
        longitude: '',
        type: 1,
      };
      this.searchType = '0';
    }
  }
}

export interface PositionSelect {
  value: string;
  label: string;
  lat: string;
  lng: string;
}

export interface TransferPosition {
  code: string;
  desc: string;
  latitude: string;
  longitude: string;
  type: number;
}
